"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/notebook/v1/admin_common.proto (package spwn.notebook.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoodsData = exports.NotebookStreamingSurveys = exports.LogiItem = exports.LogiFileData = exports.NotebookPurchasedOrder_Address = exports.NotebookPurchasedOrder_Goods = exports.NotebookPurchasedOrder_Ticket = exports.NotebookPurchasedOrder_AnsweredQuestion = exports.NotebookPurchasedOrder = exports.NotebookUserFan = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.notebook.v1.NotebookUserFan
 */
class NotebookUserFan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NotebookUserFan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotebookUserFan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotebookUserFan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(NotebookUserFan, a, b);
    }
}
exports.NotebookUserFan = NotebookUserFan;
NotebookUserFan.runtime = protobuf_1.proto3;
NotebookUserFan.typeName = "spwn.notebook.v1.NotebookUserFan";
NotebookUserFan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.notebook.v1.NotebookPurchasedOrder
 */
class NotebookPurchasedOrder extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 注文ID
         *
         * @generated from field: string order_id = 2;
         */
        this.orderId = "";
        /**
         * イベントID
         *
         * @generated from field: string event_id = 3;
         */
        this.eventId = "";
        /**
         * 決済方法
         *
         * @generated from field: string pay_type = 4;
         */
        this.payType = "";
        /**
         * 購入状態
         *
         * @generated from field: string pay_status = 5;
         */
        this.payStatus = "";
        /**
         * 購入日
         *
         * @generated from field: int64 purchased_at = 6;
         */
        this.purchasedAt = protobuf_1.protoInt64.zero;
        /**
         * 注文日
         *
         * @generated from field: int64 order_at = 7;
         */
        this.orderAt = protobuf_1.protoInt64.zero;
        /**
         * チケット
         *
         * @generated from field: repeated spwn.notebook.v1.NotebookPurchasedOrder.Ticket tickets = 8;
         */
        this.tickets = [];
        /**
         * グッズ
         *
         * @generated from field: repeated spwn.notebook.v1.NotebookPurchasedOrder.Goods goods = 9;
         */
        this.goods = [];
        /**
         * 回答した質問 (アンケートありの場合)
         *
         * @generated from field: repeated spwn.notebook.v1.NotebookPurchasedOrder.AnsweredQuestion answered_questions = 10;
         */
        this.answeredQuestions = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NotebookPurchasedOrder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotebookPurchasedOrder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotebookPurchasedOrder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(NotebookPurchasedOrder, a, b);
    }
}
exports.NotebookPurchasedOrder = NotebookPurchasedOrder;
NotebookPurchasedOrder.runtime = protobuf_1.proto3;
NotebookPurchasedOrder.typeName = "spwn.notebook.v1.NotebookPurchasedOrder";
NotebookPurchasedOrder.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_fan", kind: "message", T: NotebookUserFan },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pay_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "pay_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "purchased_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "order_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "tickets", kind: "message", T: NotebookPurchasedOrder_Ticket, repeated: true },
    { no: 9, name: "goods", kind: "message", T: NotebookPurchasedOrder_Goods, repeated: true },
    { no: 10, name: "answered_questions", kind: "message", T: NotebookPurchasedOrder_AnsweredQuestion, repeated: true },
    { no: 11, name: "address", kind: "message", T: NotebookPurchasedOrder_Address, opt: true },
]);
/**
 * @generated from message spwn.notebook.v1.NotebookPurchasedOrder.AnsweredQuestion
 */
class NotebookPurchasedOrder_AnsweredQuestion extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アンケートID (e.g.) q1, q2, q3
         *
         * @generated from field: string questionnaire_id = 1;
         */
        this.questionnaireId = "";
        /**
         * 質問文
         *
         * @generated from field: string question = 2;
         */
        this.question = "";
        /**
         * 回答
         *
         * @generated from field: string answer = 3;
         */
        this.answer = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NotebookPurchasedOrder_AnsweredQuestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotebookPurchasedOrder_AnsweredQuestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotebookPurchasedOrder_AnsweredQuestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(NotebookPurchasedOrder_AnsweredQuestion, a, b);
    }
}
exports.NotebookPurchasedOrder_AnsweredQuestion = NotebookPurchasedOrder_AnsweredQuestion;
NotebookPurchasedOrder_AnsweredQuestion.runtime = protobuf_1.proto3;
NotebookPurchasedOrder_AnsweredQuestion.typeName = "spwn.notebook.v1.NotebookPurchasedOrder.AnsweredQuestion";
NotebookPurchasedOrder_AnsweredQuestion.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "questionnaire_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.notebook.v1.NotebookPurchasedOrder.Ticket
 */
class NotebookPurchasedOrder_Ticket extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * チケット名
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * チケット価格
         *
         * @generated from field: int32 price = 2;
         */
        this.price = 0;
        /**
         * 購入数量
         *
         * @generated from field: int32 purchase_quantity = 3;
         */
        this.purchaseQuantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NotebookPurchasedOrder_Ticket().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotebookPurchasedOrder_Ticket().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotebookPurchasedOrder_Ticket().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(NotebookPurchasedOrder_Ticket, a, b);
    }
}
exports.NotebookPurchasedOrder_Ticket = NotebookPurchasedOrder_Ticket;
NotebookPurchasedOrder_Ticket.runtime = protobuf_1.proto3;
NotebookPurchasedOrder_Ticket.typeName = "spwn.notebook.v1.NotebookPurchasedOrder.Ticket";
NotebookPurchasedOrder_Ticket.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "purchase_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.notebook.v1.NotebookPurchasedOrder.Goods
 */
class NotebookPurchasedOrder_Goods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズ名
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * サブクラス名
         *
         * @generated from field: string sub_class_name = 2;
         */
        this.subClassName = "";
        /**
         * グッズ価格
         *
         * @generated from field: int32 price = 3;
         */
        this.price = 0;
        /**
         * 購入数量
         *
         * @generated from field: int32 purchase_quantity = 4;
         */
        this.purchaseQuantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NotebookPurchasedOrder_Goods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotebookPurchasedOrder_Goods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotebookPurchasedOrder_Goods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(NotebookPurchasedOrder_Goods, a, b);
    }
}
exports.NotebookPurchasedOrder_Goods = NotebookPurchasedOrder_Goods;
NotebookPurchasedOrder_Goods.runtime = protobuf_1.proto3;
NotebookPurchasedOrder_Goods.typeName = "spwn.notebook.v1.NotebookPurchasedOrder.Goods";
NotebookPurchasedOrder_Goods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sub_class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "purchase_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.notebook.v1.NotebookPurchasedOrder.Address
 */
class NotebookPurchasedOrder_Address extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 郵便番号
         *
         * @generated from field: string zip_code = 1;
         */
        this.zipCode = "";
        /**
         * 都道府県
         *
         * @generated from field: string prefecture = 2;
         */
        this.prefecture = "";
        /**
         * 市区町村
         *
         * @generated from field: string city = 3;
         */
        this.city = "";
        /**
         * 番地
         *
         * @generated from field: string street_num = 4;
         */
        this.streetNum = "";
        /**
         * その他 建物名 部屋番号
         *
         * @generated from field: string building_info = 5;
         */
        this.buildingInfo = "";
        /**
         * 名前
         *
         * @generated from field: string recipient_name = 6;
         */
        this.recipientName = "";
        /**
         * 電話番号
         *
         * @generated from field: string phone = 7;
         */
        this.phone = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NotebookPurchasedOrder_Address().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotebookPurchasedOrder_Address().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotebookPurchasedOrder_Address().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(NotebookPurchasedOrder_Address, a, b);
    }
}
exports.NotebookPurchasedOrder_Address = NotebookPurchasedOrder_Address;
NotebookPurchasedOrder_Address.runtime = protobuf_1.proto3;
NotebookPurchasedOrder_Address.typeName = "spwn.notebook.v1.NotebookPurchasedOrder.Address";
NotebookPurchasedOrder_Address.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "zip_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prefecture", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "street_num", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "building_info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "recipient_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.notebook.v1.LogiFileData
 */
class LogiFileData extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string product_name = 1;
         */
        this.productName = "";
        /**
         * @generated from field: string spwn_gid = 2;
         */
        this.spwnGid = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LogiFileData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogiFileData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogiFileData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LogiFileData, a, b);
    }
}
exports.LogiFileData = LogiFileData;
LogiFileData.runtime = protobuf_1.proto3;
LogiFileData.typeName = "spwn.notebook.v1.LogiFileData";
LogiFileData.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "spwn_gid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_set_item", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "parent_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "variation", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "fragile_items", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "cushioning_material", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "delivery_by_courier", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "warehousing_timing", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "stock_quantity", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "logi_pid", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "logi_pname", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "other", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.notebook.v1.LogiItem
 */
class LogiItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 商品ID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * 商品コード
         *
         * @generated from field: string code = 2;
         */
        this.code = "";
        /**
         * 商品名
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 価格
         *
         * @generated from field: int32 price = 4;
         */
        this.price = 0;
        /**
         * タグ
         *
         * @generated from field: repeated string tags = 5;
         */
        this.tags = [];
        /**
         * 軽減税率適用フラグ
         *
         * @generated from field: bool is_reduced_tax = 6;
         */
        this.isReducedTax = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LogiItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogiItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogiItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LogiItem, a, b);
    }
}
exports.LogiItem = LogiItem;
LogiItem.runtime = protobuf_1.proto3;
LogiItem.typeName = "spwn.notebook.v1.LogiItem";
LogiItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "is_reduced_tax", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * 配信内アンケート
 *
 * @generated from message spwn.notebook.v1.NotebookStreamingSurveys
 */
class NotebookStreamingSurveys extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アンケート内容
         *
         * @generated from field: string content = 1;
         */
        this.content = "";
        /**
         * 画像付きアンケートかどうかのフラグ
         *
         * @generated from field: bool has_images = 2;
         */
        this.hasImages = false;
        /**
         * アンケートの選択肢が格納されている配列
         *
         * @generated from field: repeated string answer_list = 3;
         */
        this.answerList = [];
        /**
         * 画像付きアンケートの画像が格納されている配列
         *
         * @generated from field: repeated string image_list = 4;
         */
        this.imageList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NotebookStreamingSurveys().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotebookStreamingSurveys().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotebookStreamingSurveys().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(NotebookStreamingSurveys, a, b);
    }
}
exports.NotebookStreamingSurveys = NotebookStreamingSurveys;
NotebookStreamingSurveys.runtime = protobuf_1.proto3;
NotebookStreamingSurveys.typeName = "spwn.notebook.v1.NotebookStreamingSurveys";
NotebookStreamingSurveys.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "has_images", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "answer_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "image_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * グッズ設定
 *
 * @generated from message spwn.notebook.v1.GoodsData
 */
class GoodsData extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int64 cart_stock = 1;
         */
        this.cartStock = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 class = 2;
         */
        this.class = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: string class_name = 3;
         */
        this.className = "";
        /**
         * @generated from field: repeated string class_thumbnails = 4;
         */
        this.classThumbnails = [];
        /**
         * @generated from field: string close_date_time = 5;
         */
        this.closeDateTime = "";
        /**
         * @generated from field: string description = 6;
         */
        this.description = "";
        /**
         * @generated from field: bool display = 7;
         */
        this.display = false;
        /**
         * @generated from field: int64 display_price = 8;
         */
        this.displayPrice = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: string eid = 9;
         */
        this.eid = "";
        /**
         * @generated from field: string event_long_title = 10;
         */
        this.eventLongTitle = "";
        /**
         * @generated from field: string event_title = 11;
         */
        this.eventTitle = "";
        /**
         * @generated from field: string expired_date_time = 12;
         */
        this.expiredDateTime = "";
        /**
         * @generated from field: repeated string hashtags = 13;
         */
        this.hashtags = [];
        /**
         * @generated from field: bool is_address_required = 14;
         */
        this.isAddressRequired = false;
        /**
         * @generated from field: bool is_address_required_no_fee = 15;
         */
        this.isAddressRequiredNoFee = false;
        /**
         * @generated from field: string name = 16;
         */
        this.name = "";
        /**
         * @generated from field: string place = 17;
         */
        this.place = "";
        /**
         * @generated from field: int64 price_jpy = 18;
         */
        this.priceJpy = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 priority = 19;
         */
        this.priority = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 purchase_limit = 21;
         */
        this.purchaseLimit = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: string release_date_time = 22;
         */
        this.releaseDateTime = "";
        /**
         * @generated from field: int64 remaining = 23;
         */
        this.remaining = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 service_fee = 24;
         */
        this.serviceFee = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: string specification = 25;
         */
        this.specification = "";
        /**
         * @generated from field: int64 sub_class = 26;
         */
        this.subClass = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: string sub_class_name = 27;
         */
        this.subClassName = "";
        /**
         * @generated from field: string thumbnail = 28;
         */
        this.thumbnail = "";
        /**
         * @generated from field: int64 total = 29;
         */
        this.total = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: string variant_thumbnail = 30;
         */
        this.variantThumbnail = "";
        /**
         * @generated from field: string id = 31;
         */
        this.id = "";
        /**
         * @generated from field: string fulfillment_shipment_ref = 32;
         */
        this.fulfillmentShipmentRef = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GoodsData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoodsData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoodsData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GoodsData, a, b);
    }
}
exports.GoodsData = GoodsData;
GoodsData.runtime = protobuf_1.proto3;
GoodsData.typeName = "spwn.notebook.v1.GoodsData";
GoodsData.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "cart_stock", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "class", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "class_thumbnails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "close_date_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "display", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "display_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "eid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "event_long_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "expired_date_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "hashtags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "is_address_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "is_address_required_no_fee", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "place", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "price_jpy", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 19, name: "priority", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "purchase_limit", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 22, name: "release_date_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "remaining", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 24, name: "service_fee", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 25, name: "specification", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "sub_class", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 27, name: "sub_class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 30, name: "variant_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "fulfillment_shipment_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=admin_common_pb.js.map